import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue'
import { Telefone } from '@/../common/types/Telefone'
import { tiposDeTelefone } from '@/shareds/sharedsTelefone'
import { obrigatorio } from '@/shareds/regras'
import { mask as vMask } from 'vue-the-mask'
import { formatarTelefone } from '../../../shareds/formatadores'

type TelefoneEditado = Telefone & { valorEditado: string }


const __default__ = {
	model: {
		prop: 'telefones',
	},
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TableTelefones',
  props: {
	telefones: {
		type: Array as PropType<Telefone[]>,
		default: () => [],
	},
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
	(e: 'input', telefones: Telefone[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const headers = [
	{ text: 'Tipo', value: 'tipo' },
	{ text: 'Número', value: 'valorEditado' },
	{ text: 'Ações', value: 'action', sortable: false },
]
const dialog = ref(false)
const indiceEdicao = ref(-1)
const telefoneEditado = ref<TelefoneEditado>({
	tipo: 'Outro',
	valor: '',
	valorEditado: '',
})
const telefoneDefault: TelefoneEditado = {
	tipo: 'Outro',
	valor: '',
	valorEditado: '',
}

function criarTelefone() {
	telefoneEditado.value = {
		...telefoneDefault,
	}
	dialog.value = true
	indiceEdicao.value = -1
}

const telefonesFormatados = computed(() => props.telefones.map(telefone => ({
	...telefone,
	valorEditado: formatarTelefone(telefone.valor),
})))

const formTitle = computed(() => indiceEdicao.value === -1 ? 'Novo Telefone' : 'Editar Telefone')

function editItem(item: TelefoneEditado) {
	telefoneEditado.value = { ...item }
	indiceEdicao.value = telefonesFormatados.value.indexOf(item)
	dialog.value = true
}

function deleteItem(item: TelefoneEditado) {
	if  (!window.confirm(`Deseja mesmo remover o ${item.valor}?`)) return
	const index = props.telefones.findIndex(({ valor }) => valor === item.valor)
	const telefones = [ ...props.telefones ]
	telefones.splice(index, 1)
	emit('input', telefones)
}

function close() {
	dialog.value = false
}

function save() {
	const telefones = [ ...props.telefones ]
	const { valorEditado, ...novoValor} = telefoneEditado.value
	if (indiceEdicao.value > -1) {
		telefones.splice(indiceEdicao.value, 1, novoValor)
	} else {
		telefones.push(novoValor)
	}
	emit('input', telefones)
	close()
}

return { __sfc: true,props, emit, headers, dialog, indiceEdicao, telefoneEditado, telefoneDefault, criarTelefone, telefonesFormatados, formTitle, editItem, deleteItem, close, save, tiposDeTelefone, obrigatorio, vMask }
}

})